import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Location} from '@angular/common';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false
})
export class UnauthorizedComponent implements OnInit {

  constructor(private router: Router, public location: Location) {}

  back(): void {
    this.location.back();
  }

  ngOnInit(): void {
  }

  home(): void {
    this.router.navigateByUrl('home');
  }
}
